<template>
  <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        color="primary"
        fab
        x-small
        depressed
        @click="isOpen = true"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ subrecipe ? $t('subrecipes.create') : $t('recipes.create') }}</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="newRecipeForm" v-model="form.valid">
          <v-container grid-list-xl>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-text-field
                  data-cy="recipes-name"
                  :label="$t('recipes.labels.name')"
                  v-model="form.name"
                  :rules="[validation.name]"
                  required>
                </v-text-field>
              </v-flex>
              <v-flex
                v-if="!subrecipe"
                xs12
                md12>
                <v-text-field
                  data-cy="recipes-description"
                  :label="$t('recipes.labels.description')"
                  v-model="form.description"
                  :rules="[validation.description]"
                  required>
                </v-text-field>
              </v-flex>
              <v-flex xs12 md12>
              <v-layout>
                <v-flex xs10 md11 v-if="!subrecipe">
                  <v-select
                    :label="$t('recipes.labels.section')"
                    v-model="form.section"
                    :items="sections"
                    item-text="name"
                    item-value="_id"
                    :rules="[validation.section]"
                    class="my-select"
                  />
                </v-flex>
                <v-flex>
                  <NewSection ref="onOpenCreateNewSection" class="my-button" /> <!-- Agrega una clase personalizada -->
                </v-flex>
              </v-layout>
            </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="error"
          class="mr-4"
          rounded
          small
          depressed
          @click="closeDialog">
          {{ $t('recipes.close') }}
        </v-btn>
        <v-btn
          data-cy="recipes-save"
          color="primary"
          class="mr-4"
          rounded
          small
          depressed
          :disabled="!form.valid"
          @click="submit">
          {{ $t('recipes.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import { required, string, isnil } from 'vue-mc/validation'
import NewSection from '@/components/modals/NewSection'

export default {
  props: {
    subrecipe: {
      type: Boolean,
      default: false
    }
  },
  components: {
    NewSection
  },
  data () {
    return {
      overlay: false,
      isOpen: false,
      form: {
        name: null,
        description: null,
        area: this.$store.state.area.id,
        section: null
      },
      validation: {
        description: string.or(isnil),
        name: required.and(string),
        section: required
      }
    }
  },
  computed: {
    sections: function () {
      return (this.$store.state.currentRestaurant.sections.data || [])
        .filter(section => section.area && (section.area === this.$store.state.area._id || section.area._id === this.$store.state.area._id))
    },
    restaurant () {
      return this.$store.state.currentRestaurant.data._id
    }
  },
  methods: {
    submit: async function () {
      this.$refs.newRecipeForm.validate()
      if (this.form.valid) {
        const payload = this.form
        payload.restaurant = this.restaurant
        payload.subrecipe = this.subrecipe
        if (!payload.section) delete payload.section
        try {
          await this.$api.post(`/v1/recipes`, payload)
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    closeDialog () {
      this.$refs.newRecipeForm.reset()
      this.isOpen = false
      this.form = {
        name: null,
        description: null,
        area: this.$store.state.area.id,
        section: null
      }
      this.$emit('close', false)
    },
    openCreateNewSection () {
      this.$refs.onOpenCreateNewSection.open()
    }
  }
}
</script>
